var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as React from 'react';
function SvgCompare(props) {
    return (React.createElement("svg", __assign({ viewBox: '0 0 35 37' }, props),
        React.createElement("path", { d: 'M23.7.677l.093.044 10 5.625a.75.75 0 01.095 1.245l-.095.063-10 5.625a.75.75 0 01-.821-1.252l.085-.056 7.505-4.221H2a.75.75 0 01-.102-1.493L2 6.25h28.562l-7.505-4.221a.75.75 0 01-.33-.93l.044-.092a.75.75 0 01.93-.33zm-13.4 23l-.093.044-10 5.625a.75.75 0 00-.095 1.245l.095.063 10 5.625a.75.75 0 00.821-1.252l-.085-.056-7.505-4.221H32a.75.75 0 00.102-1.493L32 29.25H3.438l7.505-4.221a.75.75 0 00.33-.93l-.044-.092a.75.75 0 00-.93-.33z' })));
}
export default SvgCompare;
//# sourceMappingURL=Compare.js.map